import {
  PageBlueprint,
  createFrontendPlugin,
  createRouteRef,
} from '@backstage/frontend-plugin-api';
import SettingsEthernetIcon from '@material-ui/icons/SettingsEthernet';

// The route ref, title and icon make this a nav item, but Sidebar.tsx takes it
// out of the sidebar (`nav.take('page:ip-lookup')`): the page is reached from
// Platform Tools (modules/platformTools).
const rootRouteRef = createRouteRef();

/** Resource lookup page (TOPS-1139, TOPS-1142). */
const resourceLookupPage = PageBlueprint.make({
  params: {
    path: '/resource-lookup',
    routeRef: rootRouteRef,
    title: 'Resource lookup',
    icon: <SettingsEthernetIcon />,
    loader: () => import('./ResourceLookupPage').then(m => <m.ResourceLookupPage />),
  },
});

// The page was /ip-lookup before it searched more than IPs, and that link has
// been handed out. No route ref and no icon, so it stays out of the sidebar.
const legacyIpLookupPage = PageBlueprint.make({
  name: 'legacy-ip-lookup',
  params: {
    path: '/ip-lookup',
    loader: () => import('./ResourceLookupPage').then(m => <m.ResourceLookupPage />),
  },
});

export const ipLookupPlugin = createFrontendPlugin({
  pluginId: 'ip-lookup',
  title: 'Resource lookup',
  routes: { root: rootRouteRef },
  extensions: [resourceLookupPage, legacyIpLookupPage],
});
